import axios, { apiBaseURL } from './axios'

const projectsBaseURL = `${apiBaseURL}/verticals`

export default class VerticalsApi {
  static getVerticals(): Promise<IVerticals> {
    return axios.get(projectsBaseURL)
  }
}
